import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title
      ? `${title} - Zonvex`
      : "Zonvex - Social Casino Entertainment";
  }, [title]);
};